/*  英文包  */
import eyLocale from 'element-ui/lib/locale/lang/ru-RU'
const ey = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'Облачный диск',
        'headerlangSelect' : 'Пожалуйста, выберите язык',
        'headerLoginOut' : 'Выйти',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'Все файлы',
        'sideMenuPhoto' : 'изображение',
        'sideMunsDoc' : 'файл',
        'sideMenuVideo' : 'видео',
        'sideMenuSeed' : 'семя',
        'sideMenuMusic' : 'музыка',
        'sideMenuOrther' : 'другое',
        'sideMenuShareName' : 'Моя доля',
        'sideMenuCollectName' : 'Мусорная корзина',

        /*  用户语言设定 */
        'mainUpload' : 'Загрузить',
        'mainBuildDir' : 'Новая папка',
        'mainDownloadOutline' : 'Скачать в автономном режиме',
        'mainSearch' : 'Поиск файлов',
        'mainAllFile' : 'Все файлы',
        'mainFile' : 'файл',
        'mainSize' : 'размер',
        'mainDate' : 'дата',
        'mainFileDel' : 'Удалить',
        'mainConfirmDel' : 'Подтвердите удаление?',
        'sure' : 'Подтверждение',
        'cancel' : 'отменен',
        'mainReturn' : 'Вернуться к',
        'mainPagePrev' : 'предыдущий',
        'mainPageNext' : 'Следующая страница',
        'mainLoaded' : 'Загруженный',
        'mainTotal' : 'общий',
        'mainUnit' : 'статья',
        'dilatation' : 'расширение',
        /*  回收站设定  */
        'mainHeaderTitle' : 'Совет: Корзина не занимает место на сетевом диске.',
        'mainHeaderButton' : 'Пустая корзина',
        'collectName' : 'Мусорная корзина',
        'mainRevertIts' : 'снижение',
        'mianDelData' : 'Удалить время',

        'confirmClear' : 'Подтвердить очистку выбранных файлов? (Не удается восстановить после очистки)',
        'confirmClearAll' : 'Вы уверены, что хотите очистить корзину?',

        /*  其他设定 */
        'messageBoxTitle' : 'подсказка',
        'messageBoxConfirmRevert' : 'Подтвердить восстановление выбранного файла?',
        'loading' : 'Загрузка ...',
        'loaded' : 'Нет данных',

        'messageMoveTo' : 'Переместить в',
        'filterNotice' : 'Введите ключевые слова для фильтрации',
        'messageLoaded' : 'Скачано:',
        'messageMovetion' : 'Перемещение файла',

        'messageMissKeyWord' : 'Пожалуйста, введите ключевые слова для поиска',
        'messageFolderLayersLimit' : 'Создание не удалось Глубина иерархии папок не превышает 5 уровней',
        'messageSameFolderName' : 'Не удалось создать файл с таким же именем',
        'messageEmptyFolderName' : 'Пожалуйста, введите имя папки',
        'messageMoveSame' : 'Невозможно переместить в ту же папку',
        'messageActionError' : 'Операция не удалась',
        'messageActionSuccess' : 'Операция прошла успешно',
        'messageServerIsBusy' : 'Сервер занят',
        'messageUploadOverLimit' : 'Выбрано слишком много файлов (в течение 5)',
        'messageDiskFreeFull' : 'Недостаточно места для пользователя',
        'messageUploadTypeError' : 'Невозможно загрузить файл этого типа',
        'messageUploadMaxSize' : 'Файл загрузки слишком велик (в течение 10 мес.)',
        'messageUploadSuccess' : 'Загружен успешно',
        'messageUploadFailed' : 'Загрузка не удалась',
        'messageDownloadFailed' : 'Загрузка не удалась'
    },
    ...eyLocale
};

export default ey;



// WEBPACK FOOTER //
// ./src/i18n/langs/ey.js